module.exports = __webpack_public_path__ + "static/media/settings-empty-state.27588494.png";